<template>
  <h2 class="card-title">Instructions</h2>
  <div class="text-start">
    <p>Welcome to the Course activity!</p>

    <h3 class="my-4">Introduction</h3>
    <p>
      Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod
      tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim
      veniam, quis.
    </p>
    <h3 class="my-4">
      <i class="bi bi-trophy-fill"></i> Completing the Activity
    </h3>
    <ol class="list-group list-group-numbered">
      <li class="list-group-item">
        After completing the activity, click the <strong>Submit</strong> button.
      </li>
      <li class="list-group-item">
        You will be presented with a certificate of completion to acknowledge
        your engagement with the material.
      </li>
      <li class="list-group-item">
        Click the <strong>Download</strong> button to save a copy on your
        computer which you can submit to Canvas.
      </li>
    </ol>

    <h3 class="my-4"><i class="bi bi-universal-access"></i> Accessibility</h3>
    <p>
      Our application is designed to be fully compliant with the WCAG AA 2.0
      Standards.
    </p>
  </div>
</template>

<script>
export default {
  name: "UserInstructions"
};
</script>
